const intFormatter = new Intl.NumberFormat('it-IT')
const moneyFormatter = new Intl.NumberFormat('it-IT', {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 0,
})

export function formatInt(value: number | null | undefined): string {
  return intFormatter.format(Math.round(value ?? 0))
}

export function formatMoney(value: number | null | undefined): string {
  return moneyFormatter.format(value ?? 0)
}

export function formatDate(value: string | null | undefined): string {
  return value || '—'
}
